import { createContext, useContext } from 'react';

import { useAppStore } from './appStore';

/* Ce qui n'est pas de l'état mais que les écrans utilisent : traitements métier, valeurs
   dérivées, navigation, références. Fourni une seule fois par AppInner. */
export const AppContext = createContext(null);

/** Accès unique pour les écrans : état (store) + traitements et valeurs dérivées (contexte). */
export function useApp() {
  const etat = useAppStore();
  const reste = useContext(AppContext);
  return { ...etat, ...reste };
}
